import { BiLogoFacebookSquare } from 'react-icons/bi';
import { IDeviceStateControllerReturn } from '../../../../../commonreact/main/services/devicestate/DeviceStateController';
import AppCSSService from '../../services/AppCSSService';

interface IProps {
  dsc: IDeviceStateControllerReturn;
}

const PublicFooter = (props: IProps) => {

  const getManuals = () => {
    return <div className='flex flex-col'>
      <h4 >Manuals</h4>
      <ul>
        <li>General Usage</li>
        <li>How to Improvise</li>
      </ul>
    </div>
  }

  const getMadeFor = () => {
    return <div className='flex flex-col'>
      <h4>Made for</h4>
      <ul>
        <li>Guitar Players</li>
        <li>Bass Players</li>
        <li>Keyboard Players</li>
        <li>Other Solo Instrumentalist</li>
      </ul>
    </div>
  }

  const getBottom = () => {
    return <div className='w-full items-center flex flex-row border-t'>
      <div className="m-2 mt-4">
        <BiLogoFacebookSquare color={"gray"} size={50} />
      </div>
      <div className='ml-auto'>
        <p className='text-white text-base'>
          © 2024 Jan Brinkel, Jens Legler
        </p>
      </div>
    </div>
  }

  return (
    <div className={`w-full m-0 p-2 rounded-xl items-center justify-center bg-gray-800 h-auto overflow-y-hidden ${AppCSSService.textDefault}`}>

      <div className='flex flex-row'>
        <div className='w-1/12'></div>
        <div className='flex flex-col w-10/12'>
          <div className='flex flex-row'>

            <div className='flex flex-row w-full justify-center p-5 gap-20'>
              {/* <div>
              {getManuals()}
              </div>
              <div className='pl-5'>
              {getMadeFor()}
              </div> */}
            </div>
          </div>

          <div className='w-full flex flex-row'>
            {getBottom()}
          </div>
        </div>
      </div>
    </div>

  );
};

export default PublicFooter;
